/*
 * Sample data for the GoodUnited chart specimens. Figma: 12 / Charts / Chart compositions.
 * Values match the specimen so totals, legends and segments agree.
 */

export const MONTHS_2026 = ['Jan 2026', 'Feb 2026', 'Mar 2026', 'Apr 2026', 'May 2026', 'Jun 2026', 'Jul 2026', 'Aug 2026', 'Sep 2026', 'Oct 2026', 'Nov 2026', 'Dec 2026']

/* Revenue overview, in thousands of dollars, bottom to top. */
export const REVENUE_KEYS = [
    { key: 'birthdays', label: 'Birthdays', series: 'birthdays' },
    { key: 'general', label: 'General fundraisers', series: 'facebook' },
    { key: 'other', label: 'Other sources', series: 'other' },
    { key: 'instagram', label: 'Instagram', series: 'instagram' },
    { key: 'challenges', label: 'Challenges', series: 'challenges' }
] as const

const revenueRows: [number, number, number, number, number][] = [
    [5, 24, 6, 8, 11],
    [6, 30, 7.5, 9, 13.5],
    [5, 27, 7, 10, 12],
    [5, 23, 6, 6, 9],
    [5, 26, 6, 9, 0],
    [5, 26, 7, 8, 12],
    [5, 29, 8, 10, 13],
    [5, 29, 9, 8, 11],
    [8, 34, 8, 10, 14],
    [4, 22, 6, 6, 10],
    [5, 25, 7, 8, 12],
    [6, 33, 8, 9, 13]
]

export const REVENUE_DATA = revenueRows.map(([birthdays, general, other, instagram, challenges], index) => ({
    label: MONTHS_2026[index],
    values: { birthdays, general, other, instagram, challenges }
}))

export const REVENUE_BANDS = [
    { label: '100 Mile Run', from: 0, to: 2, row: 1 },
    { label: 'Giving Tuesday', from: 2, to: 5, row: 0 },
    { label: '50 Push ups', from: 6, to: 7, row: 0 },
    { label: '100 Mile Run', from: 8, to: 10, row: 1 },
    { label: '50 Push ups', from: 11, to: 11, row: 0 }
]

/* Subscriber trends, January to June 2026. */
export const SUBSCRIBER_TRENDS = [
    { month: 'Jan 2026', total: 7000, platform: 6200, challenges: 2800, facebook: 2400, messenger: 1100, unsubscribes: -1200 },
    { month: 'Feb 2026', total: 7800, platform: 6000, challenges: 3000, facebook: 2800, messenger: 1500, unsubscribes: -1000 },
    { month: 'Mar 2026', total: 8200, platform: 5800, challenges: 2200, facebook: 2000, messenger: 1000, unsubscribes: -900 },
    { month: 'Apr 2026', total: 8500, platform: 6400, challenges: 7000, facebook: 5500, messenger: 4400, unsubscribes: -800 },
    { month: 'May 2026', total: 9800, platform: 6200, challenges: 5000, facebook: 3200, messenger: 2500, unsubscribes: -700 },
    { month: 'Jun 2026', total: 11000, platform: 8200, challenges: 7100, facebook: 4900, messenger: 4500, unsubscribes: -500 }
]

export const SUBSCRIBER_LINES = [
    { key: 'total', label: 'Total subscribers', series: 'misc', value: '11,000' },
    { key: 'platform', label: 'Platform', series: 'platform', value: '8,200' },
    { key: 'challenges', label: 'Challenges', series: 'challenges', value: '7,100' },
    { key: 'facebook', label: 'Facebook Direct', series: 'facebook', value: '4,900' },
    { key: 'messenger', label: 'Messenger Ads', series: 'messenger', value: '4,500' },
    { key: 'unsubscribes', label: 'Unsubscribes', series: 'negative', value: '−500' }
] as const

/* Pro-Life Advocate segment, August 1 to today. */
const advocateSteps = [8420, 8440, 8430, 8470, 8460, 8500, 8540, 8520, 8580, 8620, 8600, 8660, 8710, 8690, 8760, 8740, 8800, 8880, 8860, 8940, 9020, 8990, 9080, 9140, 9120, 9210, 9300, 9280, 9370, 9420]

export const ADVOCATE_GROWTH = advocateSteps.map((value, index) => ({ day: `Aug ${index + 1}`, value }))

/* Acquisition channels, new supporters in January 2026. */
export const ACQUISITION_CHANNELS = [
    { id: 'facebook', label: 'Facebook Direct', series: 'facebook', value: 120, share: '34%' },
    { id: 'messenger', label: 'Messenger Ads', series: 'messenger', value: 80, share: '23%' },
    { id: 'platform', label: 'Platform', series: 'platform', value: 50, share: '14%' },
    { id: 'challenges', label: 'Challenges', series: 'challenges', value: 100, share: '29%' }
] as const

/* Tool performance sparkline. */
export const TOOL_SPARKLINE = [12, 14, 13, 17, 16, 19, 18, 22, 21, 24, 27]
